export enum DownloadFileTypeEnum {
  PDF = "pdf",
  WORD = ".docx",
}
